<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw BookTitlePage-rw exclude-print-rw page-open-auto-rw" epub:type="frontmatter titlepage" id="BookTitlePage2">
<div class="title-block-book-rw" id="title-block-book2">
<h1 epub:type="fulltitle" id="h138">Game On</h1>
<p class="title-sub-rw" epub:type="subtitle" id="title-sub1">A Hometown Players Novel</p>
<p class="title-author-rw" id="title-author2">Victoria Denault</p>
</div>
<div class="imprint-rw" epub:type="imprint">
<p id="p2306"><img alt="" src="Images/Forever_Yours_Red_Logo.png"/></p>
<p id="p2307">New York   Boston</p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s001-BookTitlePage-01.vue?5fe2523f